import React, { useEffect, useState } from "react";

import "./../Styles/Beads.css";
import { API } from "../../config/api";
import { useLocation, useParams } from "react-router-dom";
export default function PendingSupplier() {
  const { type } = useParams();
  const supplierType = type || "All";

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [supplierTypes, setSupplierTypes] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(supplierType);
  const [search, setSearch] = useState("");
  const [profilePreview, setProfilePreview] = useState("");
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  useEffect(() => {
    if (location.state?.status) {
      setStatusFilter(location.state.status);
    }
  }, [location.state]);
  const [statusFilter, setStatusFilter] = useState(
    location.state?.status || "All",
  );
  const [popupData, setPopupData] = useState({
    open: false,
    record: null,
    imageIndex: 0,
  });

  const fetchSupplier = async (status = "All") => {
    try {
      setLoading(true);

      const res = await fetch(
        `${API.BASE_URL}/api.php?action=supplier_status&type=${selectedSupplier}&status=${status}`,
      );

      const data = await res.json();

      if (data.status) {
        setRecords(data.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSupplier(statusFilter);
  }, [statusFilter, selectedSupplier]);

  useEffect(() => {
    fetch(`${API.BASE_URL}/api.php?action=supplier_types`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) setSupplierTypes(data.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const updateStatus = async (id, status) => {
    try {
      const fd = new FormData();

      fd.append("id", id);
      fd.append("status", status);

      // use actual supplier type
      const supplier = supplierTypes.find(
        (s) => Number(s.id) === Number(popupData.record.supplier_type_id),
      );

      const supplierType = supplier?.type;

      fd.append("type", supplierType);

      const res = await fetch(
        `${API.BASE_URL}/api.php?action=change_supplier_status`,
        {
          method: "POST",
          body: fd,
        },
      );

      const data = await res.json();

      if (data.status) {
        setPopupData({
          open: false,
          record: null,
          imageIndex: 0,
        });

        fetchSupplier(statusFilter);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const deleteBead = async (id) => {
    if (
      !window.confirm(
        "Are you sure you want to permanently delete this supplier?",
      )
    )
      return;
    try {
      const fd = new FormData();
      fd.append("id", id);
      fd.append("type", popupData.record.type);
      const res = await fetch(
        `${API.BASE_URL}/api.php?action=delete_supplier`,
        {
          method: "POST",
          body: fd,
        },
      );
      const data = await res.json();
      if (data.status) {
        setPopupData({ open: false, record: null, imageIndex: 0 });
        fetchSupplier(statusFilter);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-GB");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close profile image preview first
        if (profilePreview) {
          setProfilePreview("");
          return;
        }

        // Close supplier details popup
        if (popupData.open) {
          setPopupData({
            open: false,
            record: null,
            imageIndex: 0,
          });
          return;
        }
      }

      // Image slider navigation only when supplier popup is open
      if (popupData.open && popupData.record?.images?.length > 0) {
        const totalImages = popupData.record.images.length;

        if (e.key === "ArrowRight") {
          setPopupData((prev) => ({
            ...prev,
            imageIndex:
              prev.imageIndex < totalImages - 1 ? prev.imageIndex + 1 : 0,
          }));
        }

        if (e.key === "ArrowLeft") {
          setPopupData((prev) => ({
            ...prev,
            imageIndex:
              prev.imageIndex > 0 ? prev.imageIndex - 1 : totalImages - 1,
          }));
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [popupData.open, popupData.record, profilePreview]);

  const filteredRecords = records.filter((item) => {
    const text = search.toLowerCase();
    const searchMatch =
      item.name?.toLowerCase().includes(text) ||
      item.mobile?.toString().includes(text) ||
      item.email?.toLowerCase().includes(text) ||
      String(item.user_id).includes(text);

    const statusMatch =
      statusFilter === "All" ||
      item.status?.toLowerCase() === statusFilter.toLowerCase();

    return searchMatch && statusMatch;
  });
  useEffect(() => {
    setCurrentPage(1);
  }, [search, statusFilter, selectedSupplier]);

  const paginatedRecords = filteredRecords.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const totalPages = Math.ceil(filteredRecords.length / itemsPerPage);

  return (
    <div className="supplier-dashboard-container">
      <div className="supplier-card-wrapper">
        <h1 className="dashboard-title">
          {statusFilter} {selectedSupplier === "All" ? "All" : selectedSupplier}{" "}
          Suppliers
        </h1>

        <div className="dashboard-filter-bar">
          {/* <select
            className="filter-select-input"
            value={selectedSupplier}
            onChange={(e) => setSelectedSupplier(e.target.value)}
          >
            {supplierTypes.map((supplier) => (
              <option key={supplier.id} value={supplier.type}>
                {supplier.display_name}
              </option>
            ))}
          </select> */}
          <select
            className="filter-select-input"
            value={selectedSupplier}
            onChange={(e) => setSelectedSupplier(e.target.value)}
          >
            <option value="All">All Suppliers</option>

            {supplierTypes.map((supplier) => (
              <option key={supplier.id} value={supplier.type}>
                {supplier.display_name}
              </option>
            ))}
          </select>
          <select
            className="filter-select-input"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="All">All Statuses</option>
            <option value="Pending">Pending</option>
            <option value="Active">Active</option>
            <option value="Hide">Hide</option>
          </select>

          <input
            type="text"
            className="filter-search-input"
            placeholder="Search Name, Mobile, Email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className="counter-badge">
            Total Records: {filteredRecords.length}
          </div>
        </div>

        {loading ? (
          <div className="state-message loading-state">
            Fetching matching data records...
          </div>
        ) : filteredRecords.length === 0 ? (
          <div className="state-message empty-state">
            No matching records found.
          </div>
        ) : (
          <div className="table-responsive-container">
            <table className="supplier-data-table">
              <thead>
                <tr className="text-center">
                  <th>#</th>
                  <th>Date</th>
                  <th>User ID</th>
                  <th>Image</th> {/* New */}
                  {selectedSupplier === "All" && <th>Type</th>}
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedRecords.map((item, index) => (
                  <tr key={item.id} className="text-center">
                    <td>
                      {filteredRecords.length -
                        ((currentPage - 1) * itemsPerPage + index)}
                    </td>
                    <td>{formatDate(item.created_at)}</td>
                    <td>{item.user_id}</td>
                    <td>
                      {item.profile_image ? (
                        <img
                          src={`${API.BASE_URL}/uploads/profile/${item.profile_image}`}
                          alt={item.name}
                          onClick={() =>
                            setProfilePreview(
                              `${API.BASE_URL}/uploads/profile/${item.profile_image}`,
                            )
                          }
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "inline-flex";
                          }}
                          style={{
                            width: "45px",
                            height: "45px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                        />
                      ) : null}

                      <div
                        style={{
                          display: item.profile_image ? "none" : "inline-flex",
                          width: "45px",
                          height: "45px",
                          borderRadius: "50%",
                          background: "#f5f5f5",
                          border: "1px solid #ddd",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="bi bi-person-fill"
                          style={{
                            fontSize: "22px",
                            color: "#6c757d",
                          }}
                        ></i>
                      </div>
                    </td>
                    {selectedSupplier === "All" && (
                      <td>
                        <span className="table-status-pill">{item.type}</span>
                      </td>
                    )}
                    <td>
                      <div className="fw-bold">{item.name}</div>
                      <div className="text-muted small">
                        {item.email || "-"}
                      </div>
                    </td>

                    <td>{item.mobile}</td>

                    <td>
                      <span
                        className={`table-status-pill status-${item.status?.toLowerCase()}`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-view-info"
                        onClick={() =>
                          setPopupData({
                            open: true,
                            record: item,
                            imageIndex: 0,
                          })
                        }
                      >
                        <i className="bi bi-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="supplier-pagination">
              <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                ‹ Previous
              </button>

              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  className={`pagination-btn ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </button>
              ))}

              <button
                className="pagination-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              >
                Next ›
              </button>
            </div>
          </div>
        )}
      </div>

      {popupData.open && popupData.record && (
        <div
          className="modal-overlay-backdrop"
          onClick={() =>
            setPopupData({ open: false, record: null, imageIndex: 0 })
          }
        >
          <div
            className="modal-content-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close-trigger-btn"
              onClick={() =>
                setPopupData({ open: false, record: null, imageIndex: 0 })
              }
            >
              ✕
            </button>

            <div className="modal-split-layout">
              <div className="modal-gallery-pane">
                {popupData.record.images?.length > 0 ? (
                  <div className="slider-wrapper-viewport">
                    <img
                      src={`${API.BASE_URL}/uploads/${popupData.record.type}/${popupData.record.user_id}/${popupData.record.images[popupData.imageIndex]}`}
                      alt="Supplier Item"
                      className="slider-active-display-img"
                    />

                    {popupData.record.images.length > 1 && (
                      <>
                        <button
                          className="slider-nav-btn left-arrow"
                          onClick={() =>
                            setPopupData((p) => ({
                              ...p,
                              imageIndex:
                                p.imageIndex > 0
                                  ? p.imageIndex - 1
                                  : p.record.images.length - 1,
                            }))
                          }
                        >
                          ‹
                        </button>
                        <button
                          className="slider-nav-btn right-arrow"
                          onClick={() =>
                            setPopupData((p) => ({
                              ...p,
                              imageIndex:
                                p.imageIndex < p.record.images.length - 1
                                  ? p.imageIndex + 1
                                  : 0,
                            }))
                          }
                        >
                          ›
                        </button>
                        <div className="slider-counter-tracker">
                          {popupData.imageIndex + 1} /{" "}
                          {popupData.record.images.length}
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="slider-no-image-placeholder">
                    No Images Available
                  </div>
                )}

                {popupData.record.images?.length > 1 && (
                  <div className="gallery-micro-thumbnails">
                    {popupData.record.images.map((img, i) => (
                      <img
                        key={i}
                        src={`${API.BASE_URL}/uploads/${popupData.record.type}/${popupData.record.user_id}/${img}`}
                        className={`micro-thumb ${popupData.imageIndex === i ? "active-thumb" : ""}`}
                        onClick={() =>
                          setPopupData((p) => ({ ...p, imageIndex: i }))
                        }
                        alt=""
                      />
                    ))}
                  </div>
                )}
              </div>

              <div className="modal-data-pane">
                {/* <span
                  className={`table-status-pill status-${popupData.record.status?.toLowerCase()}`}
                  style={{ float: "right" }}
                >
                  {popupData.record.status}
                </span> */}
                <h2 className="modal-info-heading">{popupData.record.name}</h2>
                <p className="modal-info-subheading">
                  User ID: {popupData.record.user_id}
                </p>

                <hr className="modal-divider" />

                <div className="modal-info-grid">
                  <div className="grid-item">
                    <strong>Mobile:</strong> {popupData.record.mobile}
                  </div>
                  <div className="grid-item">
                    <strong>Email:</strong> {popupData.record.email || "-"}
                  </div>
                  <div className="grid-item full-width">
                    <strong>Address:</strong>{" "}
                    {popupData.record.address || "No address supplied"}
                  </div>
                  <div className="grid-item">
                    <strong>Created On:</strong>{" "}
                    {formatDate(popupData.record.created_at)}
                  </div>
                </div>

                {/* DYNAMIC ACTION BUTTONS PANEL BASED ON STATUS */}
                <div className="modal-footer-actions-panel">
                  {/* Show Approve only if current status is NOT Active and NOT Hide */}
                  {popupData.record.status?.toLowerCase() !== "active" &&
                    popupData.record.status?.toLowerCase() !== "hide" && (
                      <button
                        className="action-pill-btn btn-approve"
                        onClick={() =>
                          updateStatus(popupData.record.id, "Active")
                        }
                      >
                        <i className="bi bi-check-circle-fill me-1"></i>
                        Approve
                      </button>
                    )}

                  {/* Toggle between Hide and Unhide options */}
                  {popupData.record.status?.toLowerCase() === "hide" ? (
                    <button
                      className="action-pill-btn btn-unhide"
                      onClick={() =>
                        updateStatus(popupData.record.id, "Active")
                      }
                    >
                      <i className="bi bi-eye-fill me-1"></i>
                      Unhide
                    </button>
                  ) : (
                    <button
                      className="action-pill-btn btn-hide"
                      onClick={() => updateStatus(popupData.record.id, "Hide")}
                    >
                      <i className="bi bi-eye-slash-fill me-1"></i>
                      Hide
                    </button>
                  )}

                  <button
                    className="action-pill-btn btn-delete"
                    onClick={() => deleteBead(popupData.record.id)}
                  >
                    <i className="bi bi-trash-fill me-1"></i>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {profilePreview && (
        <div
          className="modal-overlay-backdrop"
          onClick={() => setProfilePreview("")}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "#fff",
              padding: "15px",
              borderRadius: "12px",
            }}
          >
            <button
              onClick={() => setProfilePreview("")}
              style={{
                position: "absolute",
                top: "-12px",
                right: "-12px",
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                border: "none",
                background: "#dc3545",
                color: "#fff",
                fontSize: "18px",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            <img
              src={profilePreview}
              alt="Profile"
              style={{
                maxWidth: "80vw",
                maxHeight: "80vh",
                borderRadius: "10px",
                display: "block",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
